module.exports = __webpack_public_path__ + "static/img/A61801_5.d64fb84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61801_5.png
// module id = deK/
// module chunks = 1